const storageKey = "solufy-color-theme";

const sunIcon = `<svg class="solufy-theme-icon solufy-theme-icon--sun" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4.5"></circle><line x1="12" y1="2" x2="12" y2="4.5"></line><line x1="12" y1="19.5" x2="12" y2="22"></line><line x1="4.22" y1="4.22" x2="5.99" y2="5.99"></line><line x1="18.01" y1="18.01" x2="19.78" y2="19.78"></line><line x1="2" y1="12" x2="4.5" y2="12"></line><line x1="19.5" y1="12" x2="22" y2="12"></line><line x1="4.22" y1="19.78" x2="5.99" y2="18.01"></line><line x1="18.01" y1="5.99" x2="19.78" y2="4.22"></line></svg>`;

const moonIcon = `<svg class="solufy-theme-icon solufy-theme-icon--moon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>`;

const themeIconsHtml = `<span class="solufy-theme-icon-wrap" aria-hidden="true">${sunIcon}${moonIcon}</span>`;

export function mountTheme(root = document) {
	const urlTheme = new URLSearchParams(window.location.search).get("theme");
	const saved = readSavedTheme();
	const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
	const requestedTheme = [urlTheme, saved].find(isTheme);
	let theme = requestedTheme || (prefersDark ? "dark" : "light");
	let followsSystem = !requestedTheme;

	let buttons = Array.from(root.querySelectorAll(".solufy-theme-toggle"));

	if (buttons.length === 0) {
		const nav = root.querySelector(".solufy-nav__inner");
		if (nav) {
			const button = document.createElement("button");
			button.type = "button";
			button.className = "solufy-theme-toggle";
			button.innerHTML = themeIconsHtml;
			nav.appendChild(button);
			buttons = [button];
		}
	}

	const apply = (nextTheme) => {
		theme = nextTheme;
		document.documentElement.dataset.solufyTheme = theme;
		document.documentElement.setAttribute("data-solufy-theme", theme);
		document.documentElement.style.colorScheme = `only ${theme}`;
		document.querySelector('meta[name="color-scheme"]')?.setAttribute("content", `only ${theme}`);
		const metaTheme = document.querySelector('meta[name="theme-color"]');
		if (metaTheme) {
			metaTheme.setAttribute("content", theme === "dark" ? "#071224" : "#ffffff");
		}
		buttons.forEach((btn) => {
			if (!btn.querySelector(".solufy-theme-icon-wrap")) {
				btn.innerHTML = themeIconsHtml;
			}
			btn.setAttribute("aria-label", `Switch to ${theme === "dark" ? "light" : "dark"} theme`);
			btn.setAttribute("title", `Switch to ${theme === "dark" ? "light" : "dark"} theme`);
			btn.setAttribute("aria-pressed", String(theme === "dark"));
		});
		window.dispatchEvent(new CustomEvent("solufy-theme-change", { detail: theme }));
	};

	const toggle = (e) => {
		if (e) e.preventDefault();
		const nextTheme = theme === "dark" ? "light" : "dark";
		followsSystem = false;
		try { window.localStorage.setItem(storageKey, nextTheme); } catch (error) {}
		apply(nextTheme);
	};

	buttons.forEach((btn) => {
		if (!btn.querySelector(".solufy-theme-icon-wrap")) {
			btn.innerHTML = themeIconsHtml;
		}
		if (!btn.dataset.themeMounted) {
			btn.dataset.themeMounted = "true";
			btn.addEventListener("click", toggle);
		}
	});
	apply(theme);

	const mql = window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
	const onSystemChange = (e) => {
		if (followsSystem) {
			apply(e.matches ? "dark" : "light");
		}
	};
	if (mql) {
		if (mql.addEventListener) {
			mql.addEventListener("change", onSystemChange);
		} else if (mql.addListener) {
			mql.addListener(onSystemChange);
		}
	}

	const bars = [...root.querySelectorAll(".operations-chart i")];
	const values = [38, 55, 47, 73, 68, 91];
	bars.forEach((bar, index) => {
		bar.dataset.value = `${values[index]}%`;
		bar.setAttribute("role", "img");
		bar.setAttribute("tabindex", "0");
		bar.setAttribute("aria-label", `Performance ${values[index]} percent`);
	});

	return () => {
		buttons.forEach((btn) => {
			delete btn.dataset.themeMounted;
			btn.removeEventListener("click", toggle);
		});
		if (mql) {
			if (mql.removeEventListener) {
				mql.removeEventListener("change", onSystemChange);
			} else if (mql.removeListener) {
				mql.removeListener(onSystemChange);
			}
		}
	};
}

function readSavedTheme() {
	try { return window.localStorage.getItem(storageKey); } catch (error) { return null; }
}

function isTheme(value) {
	return value === "light" || value === "dark";
}
